import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import { WEBBACK_V2_API, GROUPED_BY } from "@constants";
import {commonFiltersValue, groupedBy, isLoadingCommonFilters, isSystemBusy} from "@signals";
import { elementsInLoading, catalogueAnalyzerTabSelected } from "../../@signals";


export default function useCatalogueAnalyzerShareProductsChart() {

	const isLoading = useSignal(false)
	const data = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoading.value = true
			data.value = []
			postSubmit(`${WEBBACK_V2_API}/catalogue/share-products`, { 
				...commonFiltersValue.value, groupedBy: catalogueAnalyzerTabSelected.value
			}).then(res => data.value = res)
			.catch(() => {
				isSystemBusy.value = true
				isLoadingCommonFilters.value = false
			}).finally(() => isLoading.value = false)
		}
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'shareProductsChart']
		else{
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'shareProductsChart')
		}
	}, [isLoading.value])

	return {
		isLoading: isLoading.value,
		data: data.value,
		title: 'Top 20 Share of Products Per ' + (catalogueAnalyzerTabSelected.value === GROUPED_BY.BRAND ? 'Brands' : 'Category')
	}
}